var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationButton2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.877,
    height: 58.876,
    viewBox: "0 0 58.877 58.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message_button",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "options_button",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13183",
    "data-name": "Group 13183"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_786",
    "data-name": "Ellipse 786",
    cx: 26.853,
    cy: 26.853,
    rx: 26.853,
    ry: 26.853,
    transform: "translate(2.585 2.585)",
    fill: "#ffcf03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24374",
    "data-name": "Path 24374",
    d: "M1616.228,1519.766a26.853,26.853,0,1,1-26.853,26.854,26.854,26.854,0,0,1,26.853-26.854m0-2.584a29.438,29.438,0,1,0,29.438,29.438,29.471,29.471,0,0,0-29.438-29.438Z",
    transform: "translate(-1586.79 -1517.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24375",
    "data-name": "Path 24375",
    d: "M1632.311,1597.856c-16.7,0-30.841-8.146-35.707-19.4a26.835,26.835,0,1,0,50.841,17.025A48.412,48.412,0,0,1,1632.311,1597.856Z",
    transform: "translate(-1592.205 -1558.655)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_extension",
    "data-name": " extension",
    transform: "translate(-357.053 -273.115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 32,
    height: 32,
    transform: "translate(372.239 286.239)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M402.418,303.915a3.385,3.385,0,0,1-3.383,3.383H397v5.413a2.714,2.714,0,0,1-2.706,2.706h-5.142v-2.03a3.654,3.654,0,1,0-7.308,0v2.03h-5.142A2.714,2.714,0,0,1,374,312.711v-5.142h2.03a3.654,3.654,0,0,0,0-7.308h-2.016v-5.142a2.7,2.7,0,0,1,2.693-2.707h5.413v-2.03a3.383,3.383,0,0,1,6.766,0v2.03H394.3A2.715,2.715,0,0,1,397,295.119v5.413h2.03A3.384,3.384,0,0,1,402.418,303.915Z",
    transform: "translate(0.706 0.353)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationButton2);
export default __webpack_public_path__ + "static/media/navigation-button-2.20a92082f624f1c326b284fd355babe9.svg";
export { ForwardRef as ReactComponent };